<div class="mat-paginator-go-to">
  <mat-paginator
    [length]="length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [hidePageSize]="hidePageSize"
    [showFirstLastButtons]="showFirstLastButtons"
    (page)="paginationChange($event)"
  ></mat-paginator>

  @if (!hideGoTo && totalPages > 1) {
    <div class="go-to-container dense-3">
      <div class="go-to-label">Ir a:</div>
      <mat-form-field
        class="transparent dense-3"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <input
          matInput
          class="go-to-input"
          type="number"
          min="1"
          [max]="totalPages"
          [(ngModel)]="goTo"
          (change)="goToChange()"
          (keyup.enter)="goToChange()"
        />
      </mat-form-field>
      <span class="go-to-total">/ {{ totalPages }}</span>
    </div>
  }
</div>
